import { BaseEntity } from "yt-ng-framework";

export class KomitentZrcView extends BaseEntity{
    constructor(){
        super();
    }

    Zrc:string = null;
    Glavni:boolean = null;
    Devizni:boolean = null;
    Banka:string = null;
    Komitent: string = null;
    NacinIzmene: string = null;
    IsActive: boolean = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Zrc=input.Zrc;
        this.Glavni=input.Glavni;
        this.Devizni=input.Devizni;
        this.Banka=input.Banka;
        this.Komitent = input.Komitent;
        this.NacinIzmene = input.NacinIzmene;
        this.IsActive = input.IsActive;
        return this;
    }

    Serialize(input:KomitentZrcView){
        return input;
    }
}